import React from 'react';
import { Typography } from '../../interfaces/typography';
import { StandardContainer } from '../../utils/CommonUIComponents';
import { ExternalLink, FileText } from 'lucide-react';

export function Invoices() {
  return (
    <StandardContainer maxWidth="max-w-2xl">
      <div className="bg-white rounded-lg border border-gray-200 p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex-shrink-0 w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center">
            <FileText className="w-5 h-5 text-emerald-600" />
          </div>
          <div>
            <Typography variant="h3" color="#1F2937" fontWeight={600}>
              Billing & Invoices
            </Typography>
            <Typography variant="smallParagraph" color="#6B7280">
              Manage your billing information and download invoices
            </Typography>
          </div>
        </div>
        
        <div className="flex flex-col gap-4">
          <Typography variant="mediumParagraph" color="#374151">
            Access your complete billing history, download invoices, and update payment methods through our secure Stripe customer portal.
          </Typography>
          
          <a
            href="https://billing.stripe.com/p/login/aEU038eGWfkzbXq000"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 shadow-sm font-medium text-sm w-fit"
          >
            <span>Open Billing Portal</span>
            <ExternalLink className="w-4 h-4" />
          </a>
          
          <Typography variant="smallParagraph" color="#6B7280">
            You'll be redirected to Stripe's secure portal where you can view invoices, update payment methods, and manage your subscription.
          </Typography>
        </div>
      </div>
    </StandardContainer>
  );
}
